import React, { useContext } from 'react';
import { SafeAreaView, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { Icon } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';
import PrivacyPermissionsOverlayProps from '../PrivacyPermissionsOverlay.context';
import styles from '../PrivacyPermissionsOverlay.styles';

function Header({ children, onBackPress }) {
  const context = useContext(PrivacyPermissionsOverlayProps);
  const theme = useTheme() || LightThemeColors;
  const images = getThemeImages(theme.name);

  return (
    <SafeAreaView
      style={[styles.headerContainer, onBackPress && styles.headerWithoutTitle]}
      testID={FrameworkTestKeys.PPOHeaderSAV}
    >
      {onBackPress && (
        <TouchableWithoutFeedback testID={FrameworkTestKeys.PPOBackButton} onPress={onBackPress}>
          <Icon
            type="image"
            size={25.2}
            name={images.ic_arrow_left}
            testID={FrameworkTestKeys.PPOHeaderIcon}
          />
        </TouchableWithoutFeedback>
      )}

      {children}

      <TouchableWithoutFeedback testID={FrameworkTestKeys.PPOXIconTWF} onPress={context.onDismiss}>
        <Icon type="image" size={25.2} name={images.ic_close} testID={FrameworkTestKeys.PPOXIcon} />
      </TouchableWithoutFeedback>
    </SafeAreaView>
  );
}

Header.propTypes = {
  onBackPress: PropTypes.func,
  children: PropTypes.any,
};

export default Header;
